import React from "react";
import Timer from "../../Timer";
import { useAttendance } from "../../../hooks/useAttendance";

const AttendanceCard = ({ dashboardData }) => {
  const { checkIn, checkOut } = useAttendance();

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200">
      <div className="px-4 py-3 border-b border-gray-100">
        <h5 className="flex justify-between items-center flex-grow text-lg font-semibold text-gray-800">
          <span>Attendance</span>
        </h5>
      </div>
      <div className="p-2.5">
        <Timer />

        <button 
          disabled={dashboardData?.check_in_time} 
          onClick={checkIn} 
          className="w-full bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed text-white font-medium py-3 px-4 rounded-md transition-colors duration-200 mb-3 block"
        >
          Check In
        </button>
        
        <button 
          disabled={dashboardData?.check_out_time} 
          onClick={checkOut} 
          className="w-full bg-red-600 hover:bg-red-700 disabled:bg-gray-400 disabled:cursor-not-allowed text-white font-medium py-3 px-4 rounded-md transition-colors duration-200 block"
        >
          Check Out
        </button>
        
        <div className="mt-4 space-y-2">
          {dashboardData?.check_in_time && (
            <div className="text-sm text-gray-700">
              <span className="font-semibold">Check In Time</span>: {dashboardData?.check_in_time}
            </div>
          )}
          {dashboardData?.check_out_time && (
            <div className="text-sm text-gray-700">
              <span className="font-semibold">Check Out Time</span>: {dashboardData?.check_out_time}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AttendanceCard;